import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaReact, FaNodeJs, FaHtml5, FaCss3Alt, FaJs, FaJava, FaDatabase, FaDocker, FaGithub, FaFigma, FaTerminal 
} from 'react-icons/fa';
import { 
  SiNextdotjs, SiTailwindcss, SiExpress, SiSpringboot, SiMongodb, SiPostgresql, SiMysql, SiPostman
} from 'react-icons/si';

const iconMap = {
  FaReact: <FaReact className="text-[#61dbfb]" />,
  SiNextdotjs: <SiNextdotjs className="text-white" />,
  FaHtml5: <FaHtml5 className="text-[#e34c26]" />,
  FaCss3Alt: <FaCss3Alt className="text-[#264de4]" />,
  SiTailwindcss: <SiTailwindcss className="text-[#38b2ac]" />,
  FaJs: <FaJs className="text-[#f7df1e]" />,
  FaNodeJs: <FaNodeJs className="text-[#3c873a]" />,
  SiExpress: <SiExpress className="text-white" />,
  FaJava: <FaJava className="text-[#007396]" />,
  SiSpringboot: <SiSpringboot className="text-[#6db33f]" />,
  SiMongodb: <SiMongodb className="text-[#47a248]" />,
  SiMysql: <SiMysql className="text-[#00758f]" />,
  SiPostgresql: <SiPostgresql className="text-[#336791]" />,
  FaDatabase: <FaDatabase className="text-[#f29111]" />,
  FaGithub: <FaGithub className="text-white" />,
  FaDocker: <FaDocker className="text-[#0db7ed]" />,
  SiPostman: <SiPostman className="text-[#ef5b25]" />,
  FaTerminal: <FaTerminal className="text-[#007acc]" />,
  FaFigma: <FaFigma className="text-[#f24e1e]" />,
};

const skillsData = {
  Frontend: [
    { name: "React", logo: "FaReact" },
    { name: "Next.js", logo: "SiNextdotjs" },
    { name: "HTML5", logo: "FaHtml5" },
    { name: "CSS3", logo: "FaCss3Alt" },
    { name: "Tailwind", logo: "SiTailwindcss" },
    { name: "JavaScript", logo: "FaJs" },
  ],
  Backend: [
    { name: "Node.js", logo: "FaNodeJs" },
    { name: "Express.js", logo: "SiExpress" },
  ],
  Database: [
    { name: "MongoDB", logo: "SiMongodb" },
    { name: "MySQL", logo: "SiMysql" },
    { name: "PostgreSQL", logo: "SiPostgresql" },
  ],
  Tools: [
    { name: "Git", logo: "FaGithub" },
    { name: "Docker", logo: "FaDocker" },
    { name: "Postman", logo: "SiPostman" },
    { name: "VS Code", logo: "FaTerminal" },
    { name: "Figma", logo: "FaFigma" },
  ],
};

const SkillCard = ({ name, icon, index }) => (
  <motion.div 
    initial={{ opacity: 0, scale: 0.8 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ delay: index * 0.05 }}
    whileHover={{ y: -5, scale: 1.05 }}
    viewport={{ once: true }}
    className="glass p-3 sm:p-4 rounded-2xl flex flex-col items-center justify-center gap-2 group cursor-pointer hover:shadow-[0_0_20px_rgba(0,245,212,0.15)] hover:border-accent-primary/40 transition-all"
  >
     <div className="text-2xl sm:text-3xl group-hover:scale-110 transition-transform">
        {icon}
     </div>
     <p className="text-[10px] sm:text-xs font-mono uppercase tracking-widest text-slate-400 group-hover:text-accent-primary transition-colors text-center">{name}</p>
  </motion.div>
);

const Skills = () => {
  return (
    <div id="skills" className="w-full section-padding relative">
      <motion.div 
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="flex flex-col gap-10"
      >
        <div className="flex items-center gap-4">
          <span className="text-accent-primary font-mono text-xl">02.</span>
          <h2 className="text-3xl sm:text-4xl font-display font-bold">Tech Stack & Skills</h2>
          <div className="h-[1px] flex-grow bg-slate-800 ml-4 max-w-[300px]" />
        </div>

        <div className="space-y-12">
          {Object.entries(skillsData).map(([category, items], catIdx) => (
            <div key={catIdx} className="space-y-6">
               <h3 className="text-xl font-mono text-slate-300 border-l-4 border-accent-primary pl-4">{category}</h3>
               <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-4 sm:gap-6">
                  {items.map((skill, idx) => (
                    <SkillCard 
                      key={idx} 
                      name={skill.name} 
                      icon={iconMap[skill.logo]} 
                      index={idx}
                    />
                  ))}
               </div>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default Skills;
